import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Checkbox,
  TableFooter,
  TablePagination,
  Input,
  Typography,
  Paper,
} from "@material-ui/core";
import React from "react";
import FilteredRow from "./filteredRow";
import { convertDate } from "../utils/dateConverter";

export default function FilteredTable({
  rowData,
  headers,
  checkedData,
  checkedHandler,
  allItemsSelected,
  page,
  rowsPerPage,
  count,
  inputHandler,
  filters,
  handleChangePage,
  handleChangeRowsPerPage,
  removeHandler,
}) {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Checkbox
                onChange={() => checkedHandler("all")}
                checked={allItemsSelected}
              />
            </TableCell>
            <TableCell>
              <Typography>{headers[0]}</Typography>
              {/* <Input
                value={filters.date}
                onInput={(event) => {
                  inputHandler(event, "date");
                }}
              /> */}
            </TableCell>
            <TableCell>
              <Typography>{headers[1]}</Typography>
              <Input
                value={filters.manufacturer}
                onInput={(event) => {
                  inputHandler(event, "manufacturer");
                }}
              />
            </TableCell>
            <TableCell>
              <Typography>{headers[2]}</Typography>
              <Input
                value={filters.model}
                onInput={(event) => {
                  inputHandler(event, "model");
                }}
              />
            </TableCell>
            <TableCell>
              <Typography>{headers[3]}</Typography>
              <Input
                value={filters.brand}
                onInput={(event) => {
                  inputHandler(event, "brand");
                }}
              />
            </TableCell>
            <TableCell>
              <Typography>{headers[4]}</Typography>
              <Input
                value={filters.calibrator}
                onInput={(event) => {
                  inputHandler(event, "calibrator");
                }}
              />
            </TableCell>
            <TableCell>
              <Typography>{headers[5]}</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rowData.map((item, i) => (
            <FilteredRow
              id={item.deviceId}
              key={"rowdata" + i}
              rowData={item}
              index={i}
              checked={checkedData[i] || false}
              checkedHandler={checkedHandler}
              convertDate={convertDate}
              removeHandler={removeHandler}
            />
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[2, 5, 10, 50]}
              rowsPerPage={rowsPerPage}
              page={page}
              count={count}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}
